import StepBucket from "pattern/StepBucket.js";


export const findMinStep = (group, stepBuckets) => {
    let {steps} = group;
    let stepNumbers = steps.map(s => findStep(stepBuckets, s));
    return Math.min(... stepNumbers.map(({stepNumber}) => stepNumber));
};

export const findStep = (stepBuckets, step) => {
    for (let stepNumber in stepBuckets) {
        let bucket = stepBuckets[stepNumber];
        if (!bucket) {
            continue;
        }
        for (let position in bucket.steps) {
            let stepData = bucket.steps[position];
            if (stepData.hasStep(step)) {
                return {stepNumber: parseInt(stepNumber), position};
            }
        }
    }
    return {stepNumber: undefined, position: undefined};
};

export const copyStepBuckets = (stepBuckets) => {
    let copied = [];
    for (let bucket of stepBuckets) {
        let _bucket = new StepBucket(bucket.track, false);;
        _bucket.steps = {
            ... bucket.steps
        };
        copied.push(_bucket);
    }
    return copied;
};
